<mat-dialog-content class="c-change-file-success-dialog">
	<h2 class="c-change-file-success-dialog__title">Datei erfolgreich hochgeladen</h2>

	<p>Die Datei {{ fileName }}, zuletzt geändert {{ lastModifiedDate }}, wurde erfolgreich hochgeladen.</p>
	@if (report.length > 0) {
		<div class="c-change-file-success-dialog__table-container">
			<table class="c-change-file-success-dialog__table">
				<thead>
				<tr>
					<th scope="col">Platzhalter</th>
					<th scope="col">Unterstützt</th>
					<th scope="col">Veraltet</th>
					<th scope="col">Ersetzt in</th>
				</tr>
				</thead>
				<tbody>
					@for (row of report; track $index) {
						<tr>
							<td>{{ row.word }}</td>
							<td>
								@if (row.isPlatzhalter) {
									<span class="c-change-file-success-dialog__placeholder-icon c-change-file-success-dialog__placeholder-icon--valid" aria-label="Ja">✓</span>
								} @else {
									<span class="c-change-file-success-dialog__placeholder-icon c-change-file-success-dialog__placeholder-icon--invalid" aria-label="Nein">✕</span>
								}
							</td>
							<td>{{ formatBoolean(row.isDeprecated) }}</td>
							<td>{{ row.isPlatzhalter ? (row.isReplacedInKorrespondenz ? 'Korrespondenz' : 'Vorlage') : '' }}</td>
						</tr>
					}
				</tbody>
			</table>
		</div>
	}

	@for (line of verdict; track $index) {
		<p class="c-change-file-success-dialog__verdict">{{ line }}</p>
	}

</mat-dialog-content>

<mat-dialog-actions>
	<button mat-flat-button dialogFocus color="primary" [mat-dialog-close]="true"
	        class="focus-inwards-dark" data-test-id="dialog-true-button">Ok
	</button>
</mat-dialog-actions>
